<template>
  <span class="tag-display">
    <mu-chip v-if="canDelete" delete color="primary" @delete="onClickDelete">
      {{tag}}
    </mu-chip>
    <span :style="{'color': themePrimaryColor}" v-else class="tag-display">
      {{tag}}
    </span>
  </span>
</template>

<script>
import theme from '@/mixins/theme.js'

export default {
  name: "Tag",
  mixins: [theme],
  props: {
    text: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      required: true
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    tag() {
      return '#' + this.text;
    }
  },
  methods: {
    onClickDelete() {
      this.$emit('onClickDelete', this.index);
    }
  }
};
</script>

<style scoped>
.tag-display {
  line-height: 32px;
  vertical-align: top;
}
</style>
